<template>
  <div class="flex">
    <div v-for="i in level" :key="i" class="-ml-[10px] h-6 w-6 first:ml-0">
      <svg width="100%" height="100%" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6290_28952)">
          <path
            d="M3.93478 10.2064C3.0472 9.75186 2.37088 8.9703 2.04849 8.02664C1.72611 7.08297 1.78286 6.05097 2.20679 5.14834C2.63071 4.24572 3.38866 3.54304 4.32074 3.18854C5.25282 2.83404 6.28615 2.85543 7.20276 3.24821C7.58007 2.77858 8.04052 2.38234 8.56116 2.07926C9.10839 1.7624 9.71275 1.5566 10.3396 1.47367C10.9665 1.39073 11.6036 1.43229 12.2144 1.59595C12.8252 1.75962 13.3977 2.04217 13.8992 2.42744C14.4006 2.8127 14.8211 3.29311 15.1366 3.84114C15.4359 4.36393 15.6366 4.93731 15.7285 5.53268C16.7187 5.65083 17.6243 6.14897 18.2542 6.92201C18.8842 7.69506 19.1893 8.68257 19.1051 9.67623C19.0209 10.6699 18.554 11.592 17.803 12.248C17.052 12.9041 16.0755 13.2428 15.0795 13.1927L13.3052 19.8145L2.16046 16.8283L3.93478 10.2064ZM3.15587 13.1134L14.3006 16.0996Z"
            fill="#1D526E"
          />
          <path
            d="M3.15587 13.1134L14.3006 16.0996M3.93478 10.2064C3.0472 9.75186 2.37088 8.9703 2.04849 8.02664C1.72611 7.08297 1.78286 6.05097 2.20679 5.14834C2.63071 4.24572 3.38866 3.54304 4.32074 3.18854C5.25282 2.83404 6.28615 2.85543 7.20276 3.24821C7.58007 2.77858 8.04052 2.38234 8.56116 2.07926C9.10839 1.7624 9.71275 1.5566 10.3396 1.47367C10.9665 1.39073 11.6036 1.43229 12.2144 1.59595C12.8252 1.75962 13.3977 2.04217 13.8992 2.42744C14.4006 2.8127 14.8211 3.29311 15.1366 3.84114C15.4359 4.36393 15.6366 4.93731 15.7285 5.53268C16.7187 5.65083 17.6243 6.14897 18.2542 6.92201C18.8842 7.69506 19.1893 8.68257 19.1051 9.67623C19.0209 10.6699 18.554 11.592 17.803 12.248C17.052 12.9041 16.0755 13.2428 15.0795 13.1927L13.3052 19.8145L2.16046 16.8283L3.93478 10.2064Z"
            stroke="#E0F0F9"
            stroke-width="1.4562"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_6290_28952">
            <rect width="20" height="20" fill="white" transform="translate(0.666992 0.667969)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  level: number;
}>();
</script>
